module.exports = __webpack_public_path__ + "b88489e5.svg";